(function () {
  document.querySelectorAll('.rh-pd').forEach(function (root) {
    var haupt = root.querySelector('.rh-pd-haupt');
    var btn = root.querySelector('.rh-pd-mehr');
    if (!haupt || !btn || btn.dataset.rhInit) return;
    var label = btn.querySelector('.rh-pd-mehr-txt');
    var sync = function () {
      if (!haupt.classList.contains('is--zu')) return;
      haupt.classList.remove('is--kurz');
      btn.style.display = '';
      var abgeschnitten = haupt.scrollHeight > haupt.clientHeight + 1;
      btn.style.display = abgeschnitten ? '' : 'none';
      haupt.classList.toggle('is--kurz', !abgeschnitten);
      btn.setAttribute('aria-expanded', 'false');
    };
    btn.addEventListener('click', function () {
      var zu = haupt.classList.toggle('is--zu');
      btn.classList.toggle('is--offen', !zu);
      btn.setAttribute('aria-expanded', String(!zu));
      if (label) label.textContent = zu ? btn.dataset.mehr : btn.dataset.weniger;
      if (zu) {
        sync();
        haupt.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    });
    btn.dataset.rhInit = '1';
    haupt.classList.add('rh-pd-ready');
    sync();
    window.addEventListener('load', sync);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(sync, 150);
    });
  });
})();
